export const Glamshop = {
  syncCouponUsage: {
    url: "/glamshop/couponusage/sync",
    method: ["POST"]
  },
  getCouponUsage: {
    url: "/glamshop/couponusage",
    method: ["GET"]
  },
  getCollections: {
    url: "/glamshop/collections",
    method: ["GET"]
  },
}